module.exports = __webpack_public_path__ + "static/img/mockup.86c0ae3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mockup.png
// module id = RFwJ
// module chunks = 1